import { Card, Stack, Typography, Divider, Chip, Box, TextField, Grid, Button, CircularProgress, debounce } from "@mui/material";
import ThemedPaper from "../core/ThemedPaper";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../state/store";
import { clearEditing, createProduct, editProduct, getCreationById, selectCreation, selectIsCreatingProduct, selectIsGettingCreation, selectIsUpdatingProduct } from "../../state/slices/creations";
import { userSlice } from "../../state/slices/user";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
// import debounce from 'lodash/debounce';

const DEBOUNCE_WAIT_MS = 100;

const MAX_PRODUCT_NAME_LENGTH = 80;


type Props = {
  isEdit?: boolean,
};

const loadProduct = debounce((idToken, productId, dispatch) => {
  return dispatch(getCreationById({ idToken, productId }))
}, DEBOUNCE_WAIT_MS);

export default function ProductEditor(props: Props = {
  isEdit: false,
}) {

  const { isEdit } = props;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const idToken = useAppSelector(userSlice.selectors.selectIdToken) ?? '';
  const product = useAppSelector(selectCreation);
  const isGettingCreation = useAppSelector(selectIsGettingCreation);
  const isUpdatingProduct = useAppSelector(selectIsUpdatingProduct);
  const isCreatingProduct = useAppSelector(selectIsCreatingProduct);

  const { productId } = useParams();

  useEffect(() => {
    if (!productId) {
      dispatch(clearEditing());
    }
    if (isEdit && productId != null) {
      loadProduct(idToken, productId, dispatch);
    }
  }, [productId, dispatch, idToken, isEdit]);


  useEffect(() => {
    if (isEdit && product) {
      settitle(product.title);
    }
  }, [product, isEdit]);

  useEffect(() => {
    return function cleanup() {
      if (isEdit) {
        dispatch(clearEditing());
        settitle('');
      }
    };
  }, [isEdit, dispatch]);

  const [title, settitle] = useState<string>('');

  if (!idToken || isGettingCreation) {
    return <CircularProgress />;
  }

  if (isEdit && !product) {
    return (
      <>Product</>
    );
  }

  const isValid = title != null && title.length < MAX_PRODUCT_NAME_LENGTH;

  return (
    <ThemedPaper elevation={2} sx={{
      p: 2,
      minWidth: 500,
    }}>
    <Card variant="outlined" sx={{ marginBottom: 1 }}>
    <Box sx={{ p: 2 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
    <Typography gutterBottom variant="h5" component="div">
    {isEdit ? 'Edit product' : 'Create a new product'}
    </Typography>
    <Typography gutterBottom variant="h6" component="div">

    </Typography>
    </Stack>

    </Box>
    <Divider />
    <Box sx={{ p: 2 }}>
    <Stack direction="column" spacing={2}>
    <TextField
        value={title}
        label="Course Name" variant="filled" fullWidth
        error={!!title && (title.length > MAX_PRODUCT_NAME_LENGTH)}
        onChange={(e) => settitle(e.target.value)}
            />
      <Divider>Actions</Divider>
      <Stack direction="column" spacing={2}>
      <LoadingButton variant="contained"
        loading={isUpdatingProduct || isCreatingProduct}
        disabled={!isValid}
        onClick={() => {
          const params = {
            idToken,
            productDetails: {
              id: isEdit ? product?.id : undefined,
              title: title ?? '',
            },
          };
          const action = isEdit ? editProduct(params) : createProduct(params);
          dispatch(action).then(() => navigate('/creations'));
          }}>
          Save
        </LoadingButton>
      </Stack>
    </Stack>
    </Box>
    </Card>
    </ThemedPaper>
  );
}